import React from 'react';
import { Stack, ImageListItemBar, Box, Skeleton, Link as MuiLink } from '@mui/material';
import CameraImage from 'components/CameraImage';
import { Link } from 'react-router-dom';
import { Camera } from 'types/Camera';

function CamerasList({
  camNamesToShow,
  loadingCamerasList,
  cameras,
  refetchCamerasList,
}: {
  camNamesToShow: string[] | null;
  loadingCamerasList: boolean;
  cameras: Camera[] | undefined;
  refetchCamerasList: () => void;
}) {
  if (loadingCamerasList) {
    return (
      <Stack direction="row" spacing={1} sx={{ mt: 1 }}>
        {Array.from({ length: 4 }).map((_, index) => (
          <Box key={index} sx={{ position: 'relative', height: 170, width: 250 }}>
            <CameraImage.Loading />
            <ImageListItemBar
              title={<Skeleton />}
              sx={{
                borderBottomLeftRadius: '4px',
                borderBottomRightRadius: '4px',
              }}
            />
          </Box>
        ))}
      </Stack>
    );
  }

  return (
    <Box
      sx={{
        mt: 1,
        gap: 1,
        display: 'flex',
        overflowY: 'hidden',
        overflowX: 'auto',
        flex: '0 0 auto',
      }}
      onWheel={(e) => {
        e.currentTarget.scrollLeft += e.deltaY;
      }}
    >
      {cameras
        ?.filter((camera) => (camNamesToShow ? camNamesToShow.includes(camera.name) : true))
        ?.map((camera) => (
          <Box
            key={camera.name}
            sx={{
              position: 'relative',
              height: 170,
              minWidth: 170,
              maxWidth: '100%',
              cursor: 'pointer',
              display: 'flex',
            }}
          >
            <MuiLink
              component={Link}
              to={`/cameras/${camera.name}`}
              sx={{
                display: 'flex',
                flex: '1 1 auto',
                textDecoration: 'none',
              }}
            >
              <CameraImage
                snapUrl={camera.snapUrl}
                alt={camera.name}
                token={camera.token}
                height={170}
                refetchCamerasList={refetchCamerasList}
              />
              <ImageListItemBar
                title={camera.name}
                sx={{
                  borderBottomLeftRadius: '4px',
                  borderBottomRightRadius: '4px',
                }}
              />
            </MuiLink>
          </Box>
        ))}
    </Box>
  );
}

export default CamerasList;
